export function isElementNotCovered(element) {
	if (!element) return false;

	const rect = element.getBoundingClientRect();
	const pointsToCheck = [
		{ x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 }, // Center
	];

	for (const point of pointsToCheck) {
		const elemAtPoint = document.elementFromPoint(point.x, point.y);
		if (!element.contains(elemAtPoint)) {
			return { result: false, elemAtPoint };
		}
	}

	return { result: true, elemAtPoint: null };
}
export function show(el) {
	// eslint-disable-next-line no-param-reassign
	el.style.display = 'block';
}
export function hide(el) {
	// eslint-disable-next-line no-param-reassign
	el.style.display = 'none';
}
export function extractDataTutValue(str) {
	const match = str.match(/\[data-tut="(.+)"\]/);
	return match ? match[1] : null;
}
